var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgZap = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.2 2.097c.407.165.652.58.602 1.015l-.707 6.113H19.5a.975.975 0 0 1 .772 1.57l-8.333 10.8a.975.975 0 0 1-1.74-.707l.707-6.113H4.5a.975.975 0 0 1-.772-1.57l8.334-10.8a.975.975 0 0 1 1.139-.308ZM6.485 12.825H12a.975.975 0 0 1 .969 1.087l-.43 3.714 4.977-6.451H12a.975.975 0 0 1-.968-1.087l.43-3.714-4.978 6.451Z",
    clipRule: "evenodd"
  })));
});
SvgZap.displayName = "SvgZap";
export default SvgZap;